import React, { useRef } from 'react';
import { Container } from '@fiverr-private/layout_components';
import { useEnteredView } from '@fiverr-private/hooks';
import { sendBiankaImpression } from '../../shared/biEvents';
import { EVENT_NAMES } from '../../shared/biEvents/eventNames';
import LazyImageWithSrcset from '../LazyImageWithSrcset';
import ProSectionItemBadge from '../ProSectionItemBadge';
import * as styles from './styles.ve.css';

interface ProSectionItemProps {
  src: string;
  alt: string;
  domain: string;
  domainDesktop: string;
  ctaUrl: string;
  dataScrollRotatorItem?: boolean;
  name: string;
  avatarSrc: string;
  className?: string;
  position?: number;
  isV16?: boolean;
}

const ProSectionItem = ({
  src,
  alt,
  domain,
  domainDesktop,
  ctaUrl,
  dataScrollRotatorItem = false,
  name,
  avatarSrc,
  className,
  position,
  isV16 = false,
}: ProSectionItemProps) => {
  const cardRef = useRef<HTMLDivElement>(null);

  useEnteredView(cardRef, {
    threshold: 1,
    onEntered: () => {
      sendBiankaImpression({
        eventName: EVENT_NAMES.BIANKA.EXPERTS_CAROUSEL_CARD_IS_SHOWN,
        componentName: 'experts_carousel_card',
        componentText: domain,
      });
    },
  });

  return (
    <Container
      ref={cardRef}
      width={{ default: '278px', sm: '398px', lg: '302px', xl: '374px' }}
      height={{ default: '342px', sm: '490px', lg: '368px', xl: '458px' }}
      flexShrink="0"
      position="relative"
      className={`${styles.proSectionItem} ${className}`}
      data-scroll-rotator-item={dataScrollRotatorItem}
    >
      <Container
        width="100%"
        height="100%"
        borderRadius="2xl"
        position="relative"
        overflow="hidden"
        className={styles.proSectionItemImageContainer}
      >
        <LazyImageWithSrcset
          src={src}
          alt={alt}
          imgWidth={{
            default: 278,
            sm: 398,
            lg: 302,
            xl: 374,
            xxl: 502,
            xxxl: 646,
          }}
        />
      </Container>
      <ProSectionItemBadge
        domain={domain}
        domainDesktop={domainDesktop}
        ctaUrl={ctaUrl}
        name={name}
        avatarSrc={avatarSrc}
        position={position}
        isV16={isV16}
      />
    </Container>
  );
};

export default ProSectionItem;
